import { render, staticRenderFns } from "./bheight.vue?vue&type=template&id=f512abc0&scoped=true"
import script from "./bheight.vue?vue&type=script&lang=js"
export * from "./bheight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512abc0",
  null
  
)

export default component.exports